import * as React from "react";
import { useIntl } from 'react-intl';
import ReactTooltip from 'react-tooltip';
import { Button } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faTrashAlt,
    faTimes,
    faSave,
    faPencilAlt,
} from '@fortawesome/pro-light-svg-icons';

const CompleteCountFilterActionCell = (props) => {
    const intl = useIntl();
    const { dataItem } = props;
    const inEdit = dataItem[props.editField];
    const isNewItem = dataItem[props.idField] === "" || dataItem[props.idField] === 0;

    const editDataTip = intl.formatMessage({ id: 'Control.Edit' });
    const deleteDataTip = intl.formatMessage({ id: 'Control.Delete' });
    const saveDataTip = intl.formatMessage({ id: 'Control.Save' });
    const cancelDataTip = intl.formatMessage({ id: 'Control.Cancel' });

    const saveClick = () => {
        return isNewItem ? props.add(dataItem) : props.update(dataItem);
    };

    const cancelClick = () => {
        return isNewItem ? props.discard(dataItem) : props.cancel(dataItem);
    };

    const editClick = () => {
        return props.edit(dataItem);
    };

    const removeClick = () => {
        return props.remove(dataItem);
    };

    const inEditRenderer = () => {
        return (
            <td>
                <ReactTooltip id="buttonTip" place="left" type="error" backgroundColor='#41b6e6' effect="solid" className="generic-tooltip" />
                <Button
                    color="link"
                    onClick={saveClick}
                    data-tip={saveDataTip}
                    data-for="buttonTip"
                    disabled={!dataItem.changed}
                >
                    <FontAwesomeIcon icon={faSave} />
                </Button>
                <Button
                    color="link"
                    onClick={cancelClick}
                    data-tip={cancelDataTip}
                    data-for="buttonTip"
                >
                    <FontAwesomeIcon icon={faTimes} />
                </Button>
            </td>
        );
    };

    const inNoEditRenderer = () => {
        return (
            <td>
                <ReactTooltip id="buttonTip" place="left" type="error" backgroundColor='#41b6e6' effect="solid" className="generic-tooltip" />
                <Button
                    color="link"
                    onClick={editClick}
                    data-tip={editDataTip}
                    data-for="buttonTip"
                    disabled={props.disabled}
                >
                    <FontAwesomeIcon icon={faPencilAlt} />
                </Button>
                <Button
                    color="link"
                    data-tip={deleteDataTip}
                    data-for="buttonTip"
                    onClick={removeClick}
                    disabled={props.disabled}
                >
                    <FontAwesomeIcon icon={faTrashAlt} />
                </Button>
            </td>
        );
    };

    const editActionCellRenderer = () => {
        return inEdit ? inEditRenderer() : inNoEditRenderer();
    };

    return editActionCellRenderer();
};

export default CompleteCountFilterActionCell;
